<template>
  <div>
    <div>
      <v-btn  @click="removeItem(imported.tag)" :color="ui.bkgdColor" flat dark icon>
        <v-icon :color="ui.btnColor"> highlight_off </v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";

export default {
  // eslint-disable-next-line
  mixins: [apptheme, listFunctions, docRevsModFunctions],
  computed: {
    ...mapGetters([
      "getAssetRegister",
      "getAssetRegisterCounter",
      "getFacilityRegister",
      "getFacilityRegisterCounter",
      "getEquipRegister",
      "getMaterialRegister",
      "getEquipRegisterCounter",
      "getMaterialRegisterCounter",
      "getRelationshipRegister",
      "getHazardRegisterCounter",
      "getHazardRegister",
      "getRelationshipRegisterCounter",
      "getActionList",
      "getActionListCounter"
    ]),
    // eslint-disable-next-line
    // ...mapGetters([getAssetRegister])
    list() {
      let temp = null;
      // eslint-disable-next-line
      if (this.imported.tag === "A1") {
        temp = this.getAssetRegister;
      } else if (this.imported.tag === "E1") {
        temp = this.getEquipRegister;
      } else if (this.imported.tag === "E1") {
        temp = this.getEquipRegister;
      } else if (this.imported.tag === "F1") {
        temp = this.getFacilityRegister;
      } else if (this.imported.tag === "B3") {
        temp = this.getActionList;
      } else if (this.imported.tag === "S1") {
        temp = this.getHazardRegister;
      } else if (
        this.imported.tag !== "A1" ||
        this.imported.tag !== "E1" ||
        this.imported.tag !== "B3" ||
        this.imported.tag !== "L1"
      ) {
        temp = this.getRelationshipRegister;
      } else {
        temp = [];
      }

      if (temp === null || temp === undefined) {
        temp = [];
      }
      return temp;
    }
  },
  props: {
    imported: {
      type: Object
    }
  },
  methods: {
    removeItem(tag) {
      // this.$store.dispatch("changeAttachmentList", newList);
      if (tag === "A1") {
        // eslint-disable-next-line
        let newList = this.deleteItemFromImportList(this.imported.idi, this.getAssetRegister)
        // eslint-disable-next-line
        this.$store.dispatch("changeAssetRegister", newList);
        // eslint-disable-next-line
        this.$store.dispatch("changeAssetRegisterCounter", this.getAssetRegisterCounter + 1);
        this.saveDocumentRevMod(3.13, 1); // Role updated
        this.$store.dispatch("changeDataSavePendingIndication", true);
      } else if (tag === "E1") {
        // eslint-disable-next-line
        let newList = this.deleteItemFromImportList(this.imported.idi, this.getEquipRegister)
        // eslint-disable-next-line
        this.$store.dispatch("changeEquipRegister", newList);
        // eslint-disable-next-line
        this.$store.dispatch("changeEquipRegisterCounter", this.getEquipRegisterCounter + 1);
        this.saveDocumentRevMod(3.13, 2); // Role updated
        this.$store.dispatch("changeDataSavePendingIndication", true);
      } else if (tag === "L1") {
        // eslint-disable-next-line
        let newList = this.deleteItemFromImportList(this.imported.idi, this.getMaterialRegister)
        // eslint-disable-next-line
        this.$store.dispatch("changeMaterialRegister", newList);
        // eslint-disable-next-line
        this.$store.dispatch("changeMaterialRegisterCounter", this.getMaterialRegisterCounter + 1);
        this.saveDocumentRevMod(3.13, 3); // Role updated
        this.$store.dispatch("changeDataSavePendingIndication", true);
      } else if (tag === "B3") {
        // eslint-disable-next-line
        let newList = this.deleteItemFromImportList(this.imported.idi, this.getActionList)
        // eslint-disable-next-line
        this.$store.dispatch("changeActionList", newList);
        // eslint-disable-next-line
        this.$store.dispatch("changeActionListCounter", this.getActionListCounter + 1);
        this.saveDocumentRevMod(3.13, 3); // Role updated
        this.$store.dispatch("changeDataSavePendingIndication", true);
      } else if (tag === "S1") {
        // eslint-disable-next-line
        let newList = this.deleteItemFromImportList(this.imported.idi, this.getHazardRegister)
        // eslint-disable-next-line
        this.$store.dispatch("changeHazardRegister", newList);
        // eslint-disable-next-line
        this.$store.dispatch("changeHazardRegisterCounter", this.getHazardRegisterCounter + 1);
        this.saveDocumentRevMod(3.13, 3); // Role updated
        this.$store.dispatch("changeDataSavePendingIndication", true);
      } else {
        // eslint-disable-next-line
        let newList = this.deleteItemFromImportList(this.imported.idi, this.getRelationshipRegister)
        // eslint-disable-next-line
        this.$store.dispatch("changeRelationshipRegister", newList);
        // eslint-disable-next-line
        this.$store.dispatch("changeRelationshipRegisterCounter", this.getRelationshipRegisterCounter + 1);
        this.saveDocumentRevMod(4.16, 4); // relationship added
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
